import camelcaseKeys from 'camelcase-keys'
import { pageTypes } from '@/config'
import { getFileURL } from '@/lib/helpers/FileURLGetter'
import { isURL } from '@/lib/helpers/FormValidation'

export class PagePreconfigured {
  constructor (params = {}) {
    const { pageName, featured, icon, title, coverImageFileId, active } = camelcaseKeys(params, { deep: true })
    this.title = title || []
    this.featured = featured || false
    this.pageName = pageName || null
    this.icon = icon || null
    this.coverImageFileId = coverImageFileId || null
    this.type = pageTypes.PRECONFIGURED
    this.coverImageUrl = this.coverImageFileId ? getFileURL(this.coverImageFileId) : null
    if (this.icon && this.icon.split('-')[0] !== 'mdi') {
      if (isURL(this.icon)) {
        this.iconUrl = this.icon
      } else {
        this.iconUrl = getFileURL(this.icon)
      }
    } else {
      this.iconUrl = null
    }
    this.active = true
  }
}
